export const ID_TOKEN_COOKIE = "idToken";
export const EXP_TOKEN_COOKIE = "expIn";
export const MCE_KEY_ENCRYPTED = "mceKeyEncrypted";
